import React from 'react';

import ShopAdvantages from './ShopAdvantages';
import HomeReviews from './HomeReviews';
import ViewedProducts from './ViewedProducts';

const HomePage = () => (
  <>
    <ShopAdvantages />
    <HomeReviews />
    <ViewedProducts />
  </>
);

export default HomePage;
